import { useGSAP } from "@gsap/react";
import gsap from "gsap";

/**
 * 把 useGSAP 注册进**本应用这一个** gsap 实例(GSAP 官方规定做法),副作用模块:各 entry 与
 * 测试 setup 各 import 一次即可,重复注册无害(幂等)。
 *
 * <p>★不注册会怎样:@gsap/react 内部持有自己的 `_gsap` 默认引用。打包/测试环境下 gsap 存在
 * CJS/ESM 双实例时(本仓 CLAUDE.md 记过 framer-motion 的同类 interop 坑),useGSAP 用 A 实例
 * 建 context,而组件里 `import gsap from "gsap"` 建的 tween 属于 B 实例 → context 收不到它们 →
 * **卸载时 revert 收不干净,动画在已卸载的组件上永远跑下去**。
 *
 * <p>实测(2026-07-15,vitest+jsdom):不注册时,组件卸载后手动推进 globalTimeline,tween 的
 * progress 仍从 0 → 0.4(还活着);注册后同样操作 progress 不再变(已 kill)。本仓 16 处 useGSAP
 * 此前全无注册,故全部受影响 —— 悬浮球尤其明显:它的 mode 每次 hover 都变,每变一次就漏一条
 * 眨眼/呼吸链,越用越多。
 */
gsap.registerPlugin(useGSAP);
